import { useState, useEffect, useRef } from "react";

import { useSnackbarAlert } from "../../context/snackbarAlert";
import { useParams } from "react-router-dom";
import { Grid } from "@mui/material";
import LoaderWrapper from "../../components/wrapper/LoaderWrapper";
import { useAsync, useAsyncFn } from "../../hooks/useAsync";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { useAuth } from "../../context/auth";
import TaskDetailsForm from "../../components/form/TaskDetailsForm";
import useTaskService from "../../services/taskService";
import { MANAGE_TASKS_PERMISSION } from "../../helpers/constants";
import useCheckPermission from "../../hooks/usePermission";
import UniversalCommunicationLogDialog from "../../components/dialog/UniversalCommunicationLogDialog";

function TaskDetailsPage(props) {
  const { t } = useTranslation();
  const snackbarAlert = useSnackbarAlert();
  const { taskId } = useParams();
  const {
    getTaskDetailsData,
    getTaskSelectingData,
    getTaskFilteringData,
    updateTaskData,
  } = useTaskService();
  const { user } = useAuth();

  const [hasPermissionToManageTasks] = useCheckPermission(
    MANAGE_TASKS_PERMISSION
  );


  const taskData = useAsync(() => getTaskDetailsData(taskId), [taskId]);
  const taskFilteringData = useAsync(getTaskFilteringData);
  const taskSelectingData = useAsync(getTaskSelectingData);

  const isLoading =
    taskData.loading ||
    taskFilteringData.loading ||
    taskSelectingData.loading;

  const updateTaskDataFn = useAsyncFn(updateTaskData);
  const onUpdatetaskDataPromise = (taskId, dataToSend) => {
    return updateTaskDataFn
      .execute(taskId, dataToSend)
      .then((data) => {
        snackbarAlert.openSuccessSnackbarAlert(
          t("snackbar_alert.task_data_updated")
        );
        return Promise.resolve(data);
      })
      .catch((error) => {
        snackbarAlert.openErrorSnackbarAlert(
          t("snackbar_alert.occurred_error_during_updating_task_data")
        );
        return Promise.reject(error);
      });
  };

  const handleCloseEnclosureDialog = (existsChanges) => {
    if (existsChanges) taskData.refetch();
  };

  const [comunicationDialogHeight, setComunnicationDialogHeight] =
    useState(475);
  const leftFormRef = useRef();

  useEffect(() => {
    if (
      leftFormRef.current &&
      !isLoading &&
      leftFormRef?.current.clientHeight > 0
    ) {
      setComunnicationDialogHeight(leftFormRef.current.clientHeight - 180);
    }
  }, [leftFormRef.current, isLoading]);

  if (isLoading) return <LoaderWrapper showLoader={true} />;

  const readOnly = taskData.value.is_closed || taskData.is_finally_closed || !hasPermissionToManageTasks;


  const tagTitle = `MySolvy | ${t("tag_title.task_details")} ${taskData.value?.task_nr
    }`;

  return (
    <>
      <Helmet>
        <title>{tagTitle}</title>
      </Helmet>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        rowSpacing={1}
        columnSpacing={1}
        alignItems="flex-start"
      >
        <Grid item xs={12} lg={7} ref={leftFormRef}>
          <TaskDetailsForm
  
            filteringData={taskFilteringData.value}
            selectingData={taskSelectingData.value}
            itemData={taskData.value}
            onUpdateDataPromise={onUpdatetaskDataPromise}
            onRefetchData={taskData.refetch}
            readOnly={readOnly}
            hasPermissionToManageTasks={hasPermissionToManageTasks}

          />
        </Grid>
        <Grid item xs={12} lg={5}>
          <UniversalCommunicationLogDialog
            showDialogAsForm
            itemId={taskData.value.order_id}
            itemType={"order"}
            showExtendedAddEnclosureDialog={true}
            onCloseEnclosureDialog={handleCloseEnclosureDialog}
            messageWindowHeight={comunicationDialogHeight}
            inputMessageFormShowOnlyAttachmentsIcon={true}
            inputMessageFormGridJustifyContent={"space-around"}
            inputMessageFormEnterButtonGridSmGrid={1.5}
          />
        </Grid> 

      </Grid>
    </>
  );
}

TaskDetailsPage.propTypes = {};

export default TaskDetailsPage;
